export default {"src":"/_next/static/media/close.e3c4083c.svg","height":34,"width":34};